/**
 * @generated SignedSource<<e3c8725b571b047f4573feab8c101d85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nav_viewer$data = {
  readonly viewer: {
    readonly account: {
      readonly id: string;
      readonly logo: string;
      readonly name: string;
      readonly uri: string;
    };
    readonly unreadBeacons: ReadonlyArray<string>;
    readonly user: {
      readonly id: string;
      readonly internalAttributes: {
        readonly dateConfigured: string | null;
      } | null;
      readonly isGuest: boolean;
      readonly isTopUser: boolean;
    };
    readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanel_viewer" | "MoreNavItem_viewer" | "NavbarAccountDropdown_viewer" | "TopUserModal_viewer" | "UpgradeLink_viewer" | "nav_CelloReferralFragment_viewer" | "nav_NotificationCenterButton_viewer">;
  };
  readonly " $fragmentType": "nav_viewer";
};
export type nav_viewer$key = {
  readonly " $data"?: nav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"nav_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "nav_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unreadBeacons",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTopUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserInternalAttributes",
              "kind": "LinkedField",
              "name": "internalAttributes",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateConfigured",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Account",
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uri",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MoreNavItem_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NavbarAccountDropdown_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UpgradeLink_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingsPanel_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "nav_NotificationCenterButton_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "nav_CelloReferralFragment_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TopUserModal_viewer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a198841728b0d1b871e6befbeaf9adce";

export default node;
